import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import { AuthContext } from '../../../shared/context/auth-context';

import './NavLinks.css';

const Navlinks = () => {
  const auth = useContext(AuthContext);
  const clientID = auth.userId

  return <ul className="nav-links"> 
    {!auth.isLoggedIn && (<li>
      <NavLink to="/connexion" exact>Connexion</NavLink>
    </li>
    )}
    {!auth.isLoggedIn && (<li>
      <NavLink to="/inscription">Inscription</NavLink>
    </li>
    )}
    
    {auth.isLoggedIn && (<li>
       
      <NavLink to="/sommaire">Sommaire</NavLink>
    </li>
    )}
    {auth.isLoggedIn && (<li>
      <NavLink to={`/${clientID}/profil`}>Profil</NavLink>
    </li>
    )}
    {auth.isLoggedIn && (<li>
      <NavLink to={`/${clientID}/documents`}>Documents</NavLink>
    </li>
    )}
    {auth.isLoggedIn && (<li>
      <NavLink to={`/${clientID}/contrat`}>Contrat</NavLink>
    </li>
    )}
    {auth.isLoggedIn && (<li>
      <NavLink to={`/${clientID}/releve`}>Relevé</NavLink>
    </li>
    )}
  </ul>
}
export default Navlinks;